import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

function findMenuItem(items, path) {
  let result = null;
  items.forEach((element) => {
    if (element.to == path) {
      result = element;
    }
    if (!result && element.items && element.items.length > 0) {
      result = findMenuItem(element.items, path);
    }
  });

  return result;
}

var store = new Vuex.Store({
  state: {
    loginData: null,
    logout: 0,
    auth: {
      token: localStorage.getItem('authToken') || '',
    },
    refresh: {
      token: localStorage.getItem('refreshToken') || '',
    },
    twoFactorMode: false,
    temporaryToken: '',
    twoFactorCode: '',
    menu: [],
    userInfo: null,
    taggedMembers: [],
    selectedMemberId: null,
    selectedMember: null,
    searchMemberFields: null,
    advancedSearch: {advancedSearch: false, includeAllPlans: false},
    notificationMessage: null,
    updateSelectedMemberNotes: 0,
    taggedIndex: 0,
  },
  mutations: {
    setLoginData(state, loginData) {
      state.loginData = loginData;
    },
    setAuthToken(state, token) {
      localStorage.setItem('authToken', token);
      state.auth.token = token;
    },
    setRefreshToken(state, token) {
      localStorage.setItem('refreshToken', token);
      state.refresh.token = token;
    },
    logout(state) {
      state.logout++;
    },
    setMenu(state, menu) {
      state.menu = menu;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setCurrentPlan(state, planId) {
      state.userInfo.CurrentPlanId = planId;
    },
    setSearchMemberFields(state, fields) {
      state.searchMemberFields = fields;
    },
    setAdvancedSearch(state, advancedSearch){
      state.advancedSearch = advancedSearch;
    },
    setSelectedMemberId(state, memberId) {
      state.selectedMemberId = memberId;
    },
    setSelectedMember(state, member) {
      state.selectedMember = member;
      if (member) {
        state.selectedMemberId = member.MembershipId;
        let index = state.taggedMembers.indexOf(member.MembershipId);
        state.taggedIndex = index >=0 && index < state.taggedMembers.length ? index : 0;
        console.log('selected member' + state.selectedMemberId);
      } else state.selectedMemberId = null;
    },
    addTaggedMember(state, member) {
      const memberId = Number(typeof member == 'object' ? member.MembershipId : member);
      const existedMember = state.taggedMembers.includes(memberId);

      if (!existedMember) state.taggedMembers.push(memberId);
      state.userInfo.HasTaggedMembers = true;
    },
    removeTaggedMember(state, member) {
      const memberId = Number(typeof member == 'object' ? member.MembershipId : member);
      state.taggedMembers = state.taggedMembers.filter((x) => {
        return x != memberId;
      });
      if (state.taggedMembers.length == 0) {
        state.userInfo.HasTaggedMembers = false;
      }
    },
    setTaggedMembers(state, members) {
      state.taggedMembers = members.map(member => 
        Number(typeof member == 'object' ? member.MembershipId : member)
      )
      
      if (state.taggedMembers.length > 0) {
        state.userInfo.HasTaggedMembers = true;
      } else {
        state.userInfo.HasTaggedMembers = false;
      }
    },
    setNotificationMessage(state, message) {
      state.notificationMessage = message;
    },
    clearTaggedMembers(state) {
      console.log('cleared');
      state.userInfo.HasTaggedMembers = false;
      state.taggedMembers = [];
    },
    setUpdateSelectedMemberNotes(state) {
      state.updateSelectedMemberNotes += 1;
    },
    setTaggedIndex(state, index) {
      if (index < state.taggedMembers.length) state.taggedIndex = index;
    },
    setTwoFactorMode(state, tempToken){
      if (tempToken){
        state.twoFactorMode = true;
        state.temporaryToken = tempToken;
      } else {
        state.twoFactorMode = false;
        state.temporaryToken = ''
      }
    },
    setTwoFactorCode(state, code){
      state.twoFactorCode = code;
    }
  },
  getters: {
    loginData: (state) => {
      return state.loginData;
    },
    logout: (state) => {
      return state.logout;
    },
    token: (state) => {
      return state.auth.token;
    },
    refreshToken: (state) => {
      return state.refresh.token;
    },
    userInfo: (state) => {
      return state.userInfo;
    },
    tfaCode: (state) => {
      return state.twoFactorCode;
    },
    menu: (state) => {
      return state.menu;
    },
    currentPlanId: (state) => {
      if (state.userInfo) {
        return state.userInfo.CurrentPlanId;
      }
      return 0;
    },
    selectedMemberId: (state) => {
      return state.selectedMemberId;
    },
    selectedMember: (state) => {
      return state.selectedMember;
    },
    searchMemberFields: (state) => {
      return state.searchMemberFields;
    },
    advancedSearch: (state) => {
      return state.advancedSearch;
    },
    taggedMembers: (state) => {
      return state.taggedMembers;
    },
    notificationMessage: (state) => {
      return state.notificationMessage;
    },
    getUserPermission: (state) => (param) => {
      if (state.menu && state.menu.length > 0) {
        const menuItem = findMenuItem(state.menu, param);
        return menuItem ? menuItem.permission : 'Limited';
      }
    },
    updateSelectedMemberNotes: (state) => {
      return state.updateSelectedMemberNotes;
    },
    getTaggedIndex: (state) => {
      return state.taggedIndex;
    },
    getTaggedMember: (state) => {
      if (state.taggedIndex >= 0 && state.taggedIndex < state.taggedMembers.length) {
        return state.taggedMembers[state.taggedIndex];
      } else return 0;
    },
  },
  actions: {},
  modules: {},
});

export default store;
